import { AgentService } from './../services/agent.service';
import { AgentStepFormHandlerComponent } from './agent-step-form.handler';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { Location } from '@angular/common';

@Component({
  selector: 'sym-agent-step-form',
  templateUrl: './agent-step-form.component.html',
  styleUrls: ['./agent-step-form.component.scss'],
})
export class AgentStepFormComponent extends AgentStepFormHandlerComponent {
  constructor(
    service: AgentService,
    route: ActivatedRoute,
    router: Router,
    location: Location,
    settingService: SettingService,
    headerService: HeaderService
  ) {
    super(service, route, router, location, settingService, headerService);
  }
}
